import React, { useState } from 'react';
import './Dashboard.css';
import { useCustomReactQuery } from '../../utils/useCustomReactQuery';
import Spinner from '../../utils/Spinner';
import { config } from '../../utils/config';

function Cards() {
    const [activeTable, setActiveTable] = useState('active');
    const [records, error, isLoading] = useCustomReactQuery(
        `${config}/api/Company/CRUD`
    );

    if (records === undefined) {
        return <Spinner />;
    }

    const currentDate = new Date();
    const oneWeekFromNow = new Date(currentDate.getTime() + 7 * 24 * 60 * 60 * 1000);

    const activeClients = records.filter((record) => record.isActive === 1);
    const renewalClients = records.filter((record) => {
        const expireDate = new Date(record.expireDate);
        return expireDate > currentDate && expireDate <= oneWeekFromNow;
    });
    const expiredClients = records.filter((record) => new Date(record.expireDate) < currentDate);

    const handleCardClick = (tableType) => {
        setActiveTable(tableType);
    };

    const renderTable = () => {
        let clients;
        let title;

        switch (activeTable) {
            case 'active':
                clients = activeClients;
                title = 'Active Clients';
                break;
            case 'renewal':
                clients = renewalClients;
                title = 'Renewal Clients (Expiring within a week)';
                break;
            case 'expired':
                clients = expiredClients;
                title = 'Expired Clients';
                break;
            default:
                clients = activeClients;
                title = 'Active Clients';
        }

        return (
            <div className="mt-4">
            <h3 className="text-center">{title}</h3>
            <div className="table table-responsive">
                <table className="table table-striped mobile-table">
                    <thead>
                        <tr>
                            <th>Company</th>
                         
                            <th>Contact</th>
                            <th>Pan</th>

                            <th>Expired Date</th>
                            <th>Recomend Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {clients.map((client) => {
                            const expireDate = new Date(client.expireDate);
                            const remainingDays = Math.ceil((expireDate - currentDate) / (1000 * 60 * 60 * 24));
                            return (
                                <tr key={client.id}>
                                    <td data-label="Company">  <span
    style={{
      display: 'inline-block',
      width: '10px',
      height: '10px',
      borderRadius: '50%',
      backgroundColor:
        remainingDays < 0
          ? 'red'
          : remainingDays < 7
          ? '#FF788E'
          : remainingDays < 30
          ? 'blue'
          : 'green',
      marginRight: '8px', // Add some spacing between the dot and the company name
    }}
  ></span>{client.companyName}<span style={{ display: 'block' }}>{client.address}</span></td>
                      
                              
                                    <td data-label="Contact No">{client.contactNo}</td>
                                    <td data-label="Pan">{client.panNo}</td>
                                    <td data-label="Expire Date">{expireDate.toLocaleDateString()}</td>
                                    <td
  data-label="Remaining Days"
  style={{
    color:
      remainingDays < 0
        ? 'red'
        : remainingDays < 7
        ? '#FF788E'
        : remainingDays < 30
        ? 'Blue'
        : 'green',
  }}
>
  {remainingDays < 0
    ? `Expired ${Math.abs(remainingDays)} days ago`
    : `${remainingDays} Left days`}
</td>
                                    {/* <td data-label="Remaining Days">{remainingDays > 30 ? remainingDays +"Left days ": 'Expired Ago'}</td> */}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
        );
    };

    return (
        <>
            <div className="container-fluid">
                <div className="row mt-3">
                    <div className="col-md-3 col-xl-3">
                        <div className="card-status bg-c-blue order-card">
                            <div className="card-block">
                                <h6 className="m-b-20">Total clients</h6>
                                <h2 className="text-right"><i className="fa fa-cart-plus f-left"></i><span>{records.length}</span></h2>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-4 col-xl-3">
                        <div className="card-status bg-c-green order-card" onClick={() => handleCardClick('active')} style={{cursor: 'pointer'}}>
                            <div className="card-block">
                                <h6 className="m-b-20">Active License</h6>
                                <h2 className="text-right"><i className="fa fa-rocket f-left"></i><span>{activeClients.length}</span></h2>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-4 col-xl-3">
                        <div className="card-status bg-c-yellow order-card" onClick={() => handleCardClick('renewal')} style={{cursor: 'pointer'}}>
                            <div className="card-block">
                                <h6 className="m-b-20">Renewal Clients</h6>
                                <h2 className="text-right"><i className="fa fa-refresh f-left"></i><span>{renewalClients.length}</span></h2>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-4 col-xl-3">
                        <div className="card-status bg-c-pink order-card" onClick={() => handleCardClick('expired')} style={{cursor: 'pointer'}}>
                            <div className="card-block">
                                <h6 className="m-b-20"> Expired Clients </h6>
                                <h2 className="text-right"><i className="fa fa-credit-card f-left"></i><span>{expiredClients.length}</span></h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {renderTable()}
        </>
    );
}

export default Cards;